import { NgModule } from '@angular/core';

import { AdminListService } from './admin-list-service/admin-list.service';
import { ListConversionService } from './list-conversion-service/list-conversion.service';

@NgModule({
  providers: [AdminListService, ListConversionService],
})
export class AdminListsModule {}
